<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>{{$t('prenotazione.dettagli')}}</h1></div>

            <div class="content-full">
                <div v-if="this.reservation">
                    <div class="ordine">
                        {{$t('prenotazione')}} n°: {{this.reservation.id}}
                    </div>

                    <div class="dove">
                        <img src="/img/be/ico-conferma.png"><br>
                        <b>
                            {{this.reservation.n_persone}} {{$tc('prenotazioni_tavolo.persona',
                            this.reservation.n_persone)}}
                            -
                            {{moment(this.reservation.data_ora_prenotazione).locale(this.language)
                            .format('dddd DD MMMM YYYY')}}
                            {{$t('ore_in_data')}}
                            {{moment(this.reservation.data_ora_prenotazione).locale(this.language).format('HH:mm')}}
                        </b>
                        <br><br>
                        {{$t('prenotazione.riferimento')}}<br>
                        {{$t('nome')}}: {{this.reservation.nome}}<br>
                        {{$t('telefono')}}: {{this.reservation.telefono}}<br>
                        {{$t('email')}}: {{this.reservation.email}}<br><br>
                        {{$t('prenotazione.status')}}:
                        <inc-reservation-status :status="this.reservation.status"/>
                        <br><br>
                        <a href="#" v-if="!['ANNULLATO', 'RIFIUTATO'].includes(this.reservation.status)"
                           @click.prevent="show_modal = true">
                            <button type="button" class="btn btn-primary">{{$t('prenotazione.annulla')}}</button>
                        </a>
                    </div>
                    <hr>
                    <div class="dove px-5" v-if="this.reservation_restaurant_message">
                        {{$t('messaggio_locale')}}:<br/>
                        <p v-html="this.reservation_restaurant_message"></p>
                    </div>
                </div>
                <hr>
                <div class="container">
                    <div class="row row-sezione">
                        <div class="col-12 text-center">
                            <router-link :to="{name:'reservations.history'}">
                                <button type="button" class="btn btn-default">{{$t('ordine_torna_storico')}}</button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <modal-cancel-reservation v-if="this.show_modal" :phone="this.locale.telefono"
                                  @close="show_modal = false"/>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import {getReserveDetails} from '../../api/be';

    import IncReservationStatus from "./partials/IncReservationStatus";
    import Modal from "../partials/Modal";
    import ModalCancelReservation from "./partials/ModalCancelReservation";

    export default {
        name: "Details",
        components: {ModalCancelReservation, Modal, IncReservationStatus},
        data() {
            return {
                reservation: null,

                show_modal: false
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            reservation_restaurant_message: function () {
                try {
                    return this.reservation.messaggio_ristorante.replace(/(?:\r\n|\r|\n)/g, '<br/>');
                } catch (e) {
                    return '';
                }
            },
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('auth', {
                user: state => state
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            })
        },
        methods: {
            fetch: function () {
                this.showLoading(true);
                getReserveDetails(this.language, {
                    api_key: this.user.api_key,
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    id_prenotazione: this.$route.params.id
                }).then((response) => {
                    this.reservation = response.prenotazione;
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
